/**
 * OrbDocCoreConceptsClosedCircuitSLOrbDocCoreConceptsClosedCircuitSLPage
 *
 * Page component for OrbDocCoreConceptsClosedCircuitSLOrbDocCoreConceptsClosedCircuitSLPage
 * Path: /sl/docs/core-concepts/closed-circuit
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsClosedCircuitSLDocScreenView as __OrbDocCoreConceptsClosedCircuitSLDocScreenView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitSLDocScreenView';
import { OrbDocCoreConceptsClosedCircuitSLDocAnalyticsView as __OrbDocCoreConceptsClosedCircuitSLDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsClosedCircuitSLOrbDocCoreConceptsClosedCircuitSLPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsClosedCircuitSLOrbDocCoreConceptsClosedCircuitSLPage(_props: OrbDocCoreConceptsClosedCircuitSLOrbDocCoreConceptsClosedCircuitSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Zaprti krog","description":"Vsaka interakcija je zanka od dogodka nazaj do zaslona, prevajalnik pa preveri vsak njen rob.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/closed-circuit"},{"locale":"ar","path":"/ar/docs/core-concepts/closed-circuit"},{"locale":"sl","path":"/sl/docs/core-concepts/closed-circuit"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsClosedCircuitSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsClosedCircuitSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsClosedCircuitSLOrbDocCoreConceptsClosedCircuitSLPage;
